import React from 'react';
import ParentComponent from "../../Components/ParentComponent";
import Counter from "../../Components/Counter";

const main = () => {
    return (
        <div>
            <ParentComponent/>
            <Counter/>
        </div>
    );
};

export default main;
